import React, { useEffect, useState } from 'react';
import { useStaff } from '../../DataStore/StaffContext';
import ActivityLoader from '../Common/ActivityLoader';

const SubjectSection = ({onSelect}) => {
  const { staffSubjects } = useStaff();
  const [activeRecord, setActiveRecord] = useState(null);
  useEffect(()=>{
    onSelect(activeRecord);
  }, [activeRecord, onSelect]);

  if (!staffSubjects) {
    return <ActivityLoader />;
  }

  
  return (
      <div className="card shadow-sm">
        <div className="card-header bg-white d-flex justify-content-between align-items-center">
            <h6 className="mb-0 card-title">
            <i className="fa fa-book text-primary mr-2"></i>
            Staff Teaching Load
            </h6>
        </div>
        <div className="card-body overflow-auto" style={{ maxHeight: "50vh" }}>

        {Array.isArray(staffSubjects) ? (
          <table className="align-middle mb-3 table table-borderless table-striped table-hover">
            <thead>
              <tr>
                <th>#</th>
                <th>Subject</th>
                <th>Paper</th>
                <th>Class</th>
                <th>Level</th>
                <th>Stream</th>
              </tr>
            </thead>
            <tbody>
              {staffSubjects.map((load, index) => (
                <tr
                    key={load.id}
                    className={activeRecord?.id === load.id ? "table-active" : ""}
                    onClick={() => setActiveRecord(load)}
                >
                  <td>{index + 1}</td>
                  <td>{load.paper.subject.subject}</td>
                  <td>{load.paper.paper}</td>
                  <td>{load.class.class_name}</td>
                  <td>{load.class.level.level_name}</td>
                  <td>{load.stream ? load.stream.stream_name : <em>N/A</em>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="p-3 text-muted">No subjects assigned yet.</div>
        )}
      </div>
    </div>
  );
};

export default SubjectSection;
